module.exports = __webpack_public_path__ + "static/img/5.3efcf1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruselFuturo/5.jpg
// module id = 3Moh
// module chunks = 5